import { LOCALES } from "../locales";

const englishLocals = {
  [LOCALES.ENGLISH]: {
    ESS: "ESS",
    ociety: "ociety",
    Home: "Home",
    About: "About",
    "Who We Are": "Who We Are",
    "Our Team": "Our Team",
    "Join Our Team": "Join Our Team",
    "Affiliated Groups": "Affiliated Groups",
    "Contact Us": "Contact Us",
    Resources: "Resources",
    "Scholarships and Careers": "Scholarships and Careers",
    "Important Documents": "Important Documents",
    "School Support": "School Support",
    "Incident Reports": "Incident Reports",
    Accessibility: "Accessibility",
    Services: "Services",
    Store: "Store",
    Events: "Events",
    "uOttawa Engineering Competition": "uOttawa Engineering Competition",
    Conferences: "Conferences",
    "Upcoming and Recurring Events": "Upcoming and Recurring Events",
    "Engineering Students Society": "Engineering Students Society",
    "Find us on Social Media": "Find us on Social Media",
    "All fields marked with": "All fields marked with",
    "are required": "are required",
    Name: "Name",
    Subject: "Subject",
    consent_message:
      "I understand that this form is storing my submitted information so I can be contacted.",
    Submit: "Submit",
    Location: "Location",
    "Upcoming Events": "Upcoming Events",
    "Events Archive": "Events Archive",
    "Recurring Events": "Recurring Events",
    "101 Week 2026": "101 Week 2026",
    "Engineering Charity Ball 2025": "Engineering Charity Ball 2025",
    "Office Hours": "Office Hours",
    Lockers: "Lockers",
    ERTW: "ERTW",
    //'Online Store' : "Online Store"
    "team.category.vps": "Vice-Presidents",
    "team.category.managers": "Managers",
    "team.category.commissioners": "Commissioners",
    "team.category.officers": "Officers",
    "team.vacant": "Vacant",
    "team.interim": "Interim",
    "position.president": "President",
    "position.co-president": "Co-President",
    "position.vp-external": "Vice President of External Affairs",
    "position.vp-finance": "Vice President of Finance & Administration",
    "position.vp-academic": "Vice President of Academic Affairs",
    "position.vp-comms": "Vice President of Communications",
    "position.vp-internal": "Vice President of Internal Affairs",
    "position.vp-services": "Vice President of Services",
    "position.vp-social": "Vice President of Social Affairs",
    "position.vp-phil": "Vice President of Philanthropic",
    "position.vp-equity": "Vice President of Equity",
    "position.vp-sustainability": "Vice President of Sustainable Initiatives",
    "position.vp-francophone": "Vice President of Francophone",
    "position.vp-admin": "Vice President of Administration",
    "position.manager-101": "101 Week Coordinator",
    "position.manager-equity": "Manager of Equity",
    "position.manager-external-awareness": "Manager of External Awareness",
    "position.manager-it": "Manager of Information Technology",
    "position.manager-marketing": "Manager of Marketing",
    "position.manager-office": "Office Manager",
    "position.manager-social": "Manager of Social Media",
    "position.manager-sponsor": "Manager of Sponsorships",
    "position.manager-sports": "Manager of Sports",
    "position.manager-advocacy": "Manager of Student Advocacy",
    "position.manager-student-success": "Manager of Student Success",
    "position.manager-sustainability": "Manager of Sustainable Initiatives",
    "position.manager-translations": "Manager of Translations",
    "position.manager-winecheese": "Manager of Wine and Cheese",
    "position.charity-comm": "Charity Commissioner",
    "position.francophone-outreach-comm": "Francophone Outreach Commissioner",
    "position.ertw-comm": "ERTW Commissioner",
    "position.finance-comm": "Finance Commissioner",
    "position.logistics-comm": "Sponsorship Liaison Commissioner",
    "position.spirit-comm": "Commissioner of Spirit",
    "position.media-comm": "Media Commissioner",
    "position.selection-comm": "Selection Commissioner",
    "position.uoec-comm": "uOEC Commissioner",
    "position.chair": "Chair of the Board of Directors",
    "Board of Directors": "Board of Directors",
    "bod.group.officers": "Chair & Secretary",
    "bod.group.sub_associations": "Sub-Associations",
    "bod.group.representatives": "Representatives",
    "bod.group.non_voting": "Non-Voting Members",
    "bod.seat.chair": "Chair of the Board",
    "bod.seat.secretary": "Secretary",
    "bod.seat.ieee": "IEEE",
    "bod.seat.chess": "ChESS",
    "bod.seat.mess": "MESS",
    "bod.seat.csce": "CSCE",
    "bod.seat.cesa": "CESA",
    "bod.seat.sass": "SASS",
    "bod.seat.jmts": "JMTS",
    "bod.seat.eef": "EEF",
    "bod.seat.coop": "CO-OP {program}",
    "bod.seat.year": "{year} {program}",
    "bod.seat.rep": "Representative",
    "bod.year.1": "1st year",
    "bod.year.2": "2nd year",
    "bod.year.3": "3rd year",
    "bod.year.4": "4th year",
    "bod.program.chemical": "Chemical",
    "bod.program.civil": "Civil",
    "bod.program.electrical": "Electrical",
    "bod.program.mechanical": "Mechanical",
    "bod.program.biomech": "Biomedical Mechanical",
    "bod.program.software": "Software",
    "bod.program.computer": "Computer",
    "bod.program.french": "French",
    "bod.program.multidisciplinary": "Multidisciplinary Design",
  },
};
export default englishLocals;
